// extracted by mini-css-extract-plugin
export var banner = "_qn-0";
export var settingRow = "_qn-2";
export var titleIcon = "_qn-1";